export const OFFERINGS_ENDPOINTS = {
  BASE: "/v1/offerings",
  DETAIL: (id: string) => `/v1/offerings/${id}`,
  TRACKS: (id: string) => `/v1/offerings/${id}/tracks`,
} as const;
